"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const spa_core_1 = require("@episerver/spa-core");
const react_1 = __importDefault(require("react"));
const Shareticker_1 = __importDefault(require("../Shareticker/Shareticker"));
const PageImage = ({ imageData, layoutSettings, classNames, tickerBgColorClass, showTickerOnMobile }) => {
    return (react_1.default.createElement("div", { className: `page-image ${classNames || ''} ${imageData.value ? '' : 'd-none'}` },
        imageData.value &&
            react_1.default.createElement("div", { className: 'position-relative' },
                react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: imageData.value, className: "d-cover", expandedValue: imageData.expandedValue, parentVar: { lazy: false } }),
                showTickerOnMobile &&
                    react_1.default.createElement(Shareticker_1.default, { layoutSettings: layoutSettings, bgcolorClass: tickerBgColorClass })),
        react_1.default.createElement("div", { className: "l1 d-none d-sm-block" }),
        react_1.default.createElement("div", { className: "l2 d-none d-sm-block" }),
        react_1.default.createElement("div", { className: 'l3 d-none d-sm-block' })));
};
exports.default = PageImage;
